import { FormikTextField, Stack } from '@color/continuum';

const TEXT_FIELDS = [
  {
    label: 'Chromosome',
    name: 'chrom',
    isRequired: true,
  },
  { label: 'Position', name: 'pos', isRequired: true },
  { label: 'Reference', name: 'ref', isRequired: true },
  { label: 'Alternative', name: 'alt', isRequired: true },
  { label: 'Tag', name: 'tag', isRequired: false },
];

export const FormFields = () => {
  return (
    <Stack sx={{ gap: 3 }}>
      {TEXT_FIELDS.map((field) => (
        <FormikTextField
          key={field.name}
          label={field.label}
          name={field.name}
          required={field.isRequired}
        />
      ))}
    </Stack>
  );
};
